import { useQuery } from "@tanstack/react-query";
import subscriptionService from "services/admin/subscription.service";

export const useGetSubscription = (orgID: string) => {
    return useQuery({
        queryKey: ['subscription', orgID],
        queryFn: async () => {
            const response: any = await subscriptionService.getAll()
            return response?.data
        },        
    })
}